export const HIGHLIGHT_CLASS_NAME = 'hll';
// Applied to the first and last line of a selection to draw the top/bottom borders.
export const HIGHLIGHT_TOP_CLASS_NAME = 'highlight-top';
export const HIGHLIGHT_BOTTOM_CLASS_NAME = 'highlight-bottom';
export const MARKUP_FILE_TYPE = 'markup';
export const MARKUP_CONTENT_SELECTOR = '.js-markup-content';
export const ELEMENTS_PER_CHUNK = 20;
export const CONTENT_LOADED_EVENT = 'rich-content-loaded';
export const MAX_BLAME_LINES = 100;
